import classNames from 'classnames/bind';
import Icon from '../Icon/Icon';
import { IconName } from '../Icon/utils/types';
import styles from './Card.module.scss';

const cx = classNames.bind(styles);

export interface CardHeaderProps {
  title: string;
  subtitle?: string;
  smallLogo?: boolean;
  withoutLogo?: boolean;
  classes?: {
    wrapper?: string;
    title?: string;
    subtitle?: string;
    logo?: string;
  };
}

const CardHeader = (props: CardHeaderProps) => {
  const { title, subtitle, smallLogo, withoutLogo, classes } = props;

  const renderLogo = () =>
    smallLogo ? (
      <div className={cx('card-header__logo-wrapper')}>
        <Icon name={IconName.DFINLogo} width={99} height={28} />
        <Icon name={IconName.EdgarNextLogo} />
      </div>
    ) : (
      <Icon
        name={IconName.DFINLogo}
        className={cx('card-header__logo', classes?.logo)}
      />
    );

  return (
    <div className={cx('card-header', classes?.wrapper)}>
      {!withoutLogo && renderLogo()}
      <span className={cx('card-header__title', classes?.title)}>{title}</span>
      {subtitle && (
        <span className={cx('card-header__subtitle', classes?.subtitle)}>
          {subtitle}
        </span>
      )}
    </div>
  );
};

export default CardHeader;
